
    import Vue from "vue";
    import Component from "vue-class-component";
    import Colours from "@/utilities/Colours";

    @Component({})
    export default class PrimaryButton extends Vue {

        get buttonColour(): string {
            const isDisabled = Boolean(this.$attrs["disabled"]);
            return isDisabled
                ? "#888"
                : this.$store.state.clientSettings?.client?.buttonColour ?? "#88F";
        }

        get isDark(): boolean {
            const isDisabled = Boolean(this.$attrs["disabled"]);
            return !isDisabled && Colours.isDark(this.buttonColour);
        }

        // eslint-disable-next-line
        get listeners(): Record<string, Function | Function[]> {
            return { ...this.$listeners };
        }
    }
